import { Component, ViewEncapsulation } from "@angular/core";
import { ConfigurationOrganisationHierarchyNavigationService } from "./configuration-organisation-hierarchy-navigation.service";
import { ConfigurationPersonalHierarchyNavigationService } from "./configuration-personal-hierarchy-navigation.service";
import { ConfigurationTeamHierarchyNavigationService } from "./configuration-team-hierarchy-navigation.service";

@Component({
    selector: "adapt-configuration-tab-content",
    templateUrl: "./configuration-tab-content.component.html",
    styleUrl: "./configuration-tab-content.component.css",
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ConfigurationTabContentComponent {
    public readonly personalHierarchyId = ConfigurationPersonalHierarchyNavigationService.HierarchyId;
    public readonly teamHierarchyId = ConfigurationTeamHierarchyNavigationService.HierarchyId;
    public readonly organisationHierarchyId = ConfigurationOrganisationHierarchyNavigationService.HierarchyId;
}
